// fetchFaqArticleDetail.js
'use strict';
import fetch from '../resource/customFetch.js';
import getMeData from '../selector/getMeData.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import { localeConvertor } from '../resource/i18n.js';
import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
  ADD_INTERCOM_ARTICLES,
} from '../ActionTypes.js';

/**
 * Fetch faq article detail by id
 * @kind action
 * @param {string} {id} - intercom article id
 * @param {string} {language} - intercom article language
 * @param {object} { [httpProxyHeaders = {}] } - http proxy headers for SSR.
 * @return {Promise} Action promise.
 */
const fetchFaqArticleDetail =
  ({ id, language = 'en', httpProxyHeaders = {} }) =>
  async (dispatch, getState) => {
    if (!id) {
      return dispatch({ type: '' });
    }
    const token = getMeData(getState(), 'token');
    const selectPath = ['faq', language, id];
    const fetchOptions = {
      method: 'GET',
      headers: {
        ...getHeaders(),
        ...httpProxyHeaders,
      },
    };

    if (token) {
      fetchOptions.headers.Authorization = `Bearer ${token}`;
    }

    const fetchUrl = getResourceUrl({ endpoint: `/intercom/articles/${id}` });
    fetchUrl.searchParams.append(
      'lang',
      localeConvertor({
        locale: language,
        isISO639: true,
      })
    );
    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
    try {
      const response = await fetch(fetchUrl.href, fetchOptions);

      if (!response.ok) {
        await handleFetchError({ response });
      }

      const payload = await response.json();
      const articles = {
        [payload.id]: {
          [language]: payload,
        },
      };
      dispatch({
        type: ADD_INTERCOM_ARTICLES,
        payload: { articles },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchFaqArticleDetail;
